import Vue from './vueconfig.js'
import App from './App'
import router from './router.js'
import store from './store.js'
import ActionLog from './actionlog.js'

Vue.config.productionTip = false
Vue.config.errorHandler = console.error.bind(console)
Vue.config.warnHandler = console.warn.bind(console)

function launchApp() {
  if (!window.myApp) {
    window.myApp = new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  }
}

launchApp();

var _recentKeys = '';
const _devmagic = 'PIXXIDEV'
document.onkeyup = function(e){
  var e = e || window.event // for IE
  String.fromCharCode(e.which || e.keyCode)
  _recentKeys += String.fromCharCode(e.which || e.keyCode)
  if (_recentKeys.length > _devmagic.length) {
    _recentKeys = _recentKeys.slice(-8);
  }
  if (_recentKeys == _devmagic) {
    store.commit('updateDevMode', true)
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/main.js